import AddRoundedIcon from "@mui/icons-material/AddRounded"
import {
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  IconButton,
  Stack,
  Chip,
} from "@mui/material"
import { DropzoneArea } from "mui-file-dropzone"
import { useState } from "react"
import FormItem from "../ui/FormItem"
import Modal from "../ui/Modal"

const AddNoteModal = (props) => {
  const [links, setLinks] = useState([])
  const [link, setLink] = useState({ name: "", link: "" })
  const handleLinkChange = (event) => {
    const { name, value } = event.target
    setLink({
      ...link,
      [name]: value,
    })
  }
  const addLink = () => {
    setLinks([...links, link])
    setLink({ name: "", link: "" })
  }
  const removeLink = (idx) => {
    setLinks(links.filter((_, i) => i !== idx))
  }
  return (
    <Modal {...props} title="Add note" actionText="Add">
      <FormItem label="Note title">
        <TextField />
      </FormItem>
      <FormItem label="Select batches">
        <FormGroup row>
          <FormControlLabel control={<Checkbox />} label="Batch 1" />
          <FormControlLabel control={<Checkbox />} label="Batch 2" />
        </FormGroup>
      </FormItem>
      <FormItem label="Note description">
        <TextField />
      </FormItem>
      <FormItem label="Upload files">
        <DropzoneArea acceptedFiles={["application/pdf"]} useChipsForPreview />
      </FormItem>
      <FormItem label="Add online material/ video link">
        <Stack direction="row" spacing={2} alignItems="center">
          <TextField
            name="name"
            value={link.name}
            onChange={handleLinkChange}
            label="Name"
            fullWidth
          />
          <TextField
            name="link"
            value={link.link}
            onChange={handleLinkChange}
            label="Paste Link"
            fullWidth
          />
          <IconButton onClick={addLink} sx={{ flex: "none" }}>
            <AddRoundedIcon />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={1} marginTop={2} flexWrap="wrap">
          {links.map((l, i) => (
            <Chip key={i} label={l.name} onDelete={() => removeLink(i)} />
          ))}
        </Stack>
      </FormItem>
    </Modal>
  )
}

export default AddNoteModal
